
import CartList from '../pages/cart/components/CartList.vue'
import AddToCart from '../pages/cart/components/AddToCart.vue'
import TreatmentListItem from '../components/TreatmentListItem.vue'
import { User } from "@fixit/fixit-no-header/src/models";

export default {
    props: {
        treatments: {
            type: Array,
            required: true
        },
        showRecEngine: {
          type: Boolean,
          default: true
        },

        categoriesFromUrl: {
            type: Array,
            default: []
        }
    },
    components: {
        CartList,
        AddToCart,
        TreatmentListItem
    },
    data: () => ({
        currentSelectedTreatment: null,
        addedKey: 0,
        selectedDepartment: null,
        panel: [],
        recEnginePanel: [0]
    }),
    computed: {
      treatmentsByCategories() {
          let categories = this.$store.getters['treatments/getTreatmentsByCategories']
          for (const [i, category] of categories.entries()) {
              category['index'] = i
          }
          this.panel = categories.filter(x => this.categoriesFromUrl.includes(x.urlSafeName)).map(x => x.index)
          return categories
      },
      recEngineTreatments() {
        return this.$store.getters['treatments/getRecEngineItems'].map(x => { return {
            ftcCategoryImgUrlsThumbnails: x.imageUrl,
            description: x.description || '',
            treatmentName: x.title,
            treatmentId: x.id,
            notBookable: x.notBookable,
            urlSafe: x.urlSafe?.split('/')[1] || '',
            urlSafeTreatmentName: x.urlSafe?.split('/')[0] || '',
            price: x.price,
            pricePerSite: x.pricePerSite,
            subtitle: x.subtitle,
            showDescriptionDefault: x.showDescriptionDefault || false,
            isFavorite: x.isFavorite || false
          }
        })
      },
      user() {
        return new User(this.$store.getters["app/get"]("user"));
      },
    },
    methods: {
      async addOrRemove(treatment) {
          this.addedKey += 1
          this.currentSelectedTreatment = treatment
      },
    },
    beforeDestroy() {
      this.selectedDepartment = null
    }
}
